import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { startCheckout } from "@/lib/checkout";
import { T } from "@/constants/testIds";

const cards = [
  {
    id: "mensalao",
    tid: T.cardMensalao,
    num: "C · 01",
    year: "2005",
    title: "Mensalão",
    desc: "O contexto político, as investigações, o julgamento e os principais acontecimentos relacionados ao caso.",
    bg: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=1600&q=80",
  },
  {
    id: "lavajato",
    tid: T.cardLavaJato,
    num: "C · 02",
    year: "2014",
    title: "Petrobras e Lava Jato",
    desc: "O contexto das investigações envolvendo Petrobras, empreiteiras, agentes políticos e os desdobramentos da operação.",
    bg: "https://images.unsplash.com/photo-1518544801976-3e159e50e5bb?w=1600&q=80",
  },
  {
    id: "triplex",
    tid: T.cardTriplex,
    num: "C · 03",
    year: "2017",
    title: "Triplex do Guarujá",
    desc: "A cronologia das acusações, o processo judicial, as decisões e os acontecimentos jurídicos posteriores.",
    bg: "https://images.unsplash.com/photo-1430285561322-7808604715df?w=1600&q=80",
  },
  {
    id: "anospt",
    tid: T.cardAnosPT,
    num: "C · 04",
    year: "2003 – 2021",
    title: "Anos de governo do PT",
    desc: "Uma linha do tempo dos principais acontecimentos políticos dos períodos de governo do PT.",
    bg: "https://images.unsplash.com/photo-1569407228235-9051b206bd57?w=1600&q=80",
  },
];

export default function ScandalCards() {
  return (
    <section id="casos" className="relative bg-black py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-red-600" />
              <span className="eyebrow">O que você vai encontrar</span>
            </div>
            <h2 className="font-display font-black text-neutral-50 leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl max-w-3xl">
              Quatro grandes capítulos.{" "}
              <span className="text-red-600 italic">Uma única cronologia.</span>
            </h2>
          </div>
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-neutral-500 max-w-xs">
            Separamos fatos documentados, acusações formais e decisões judiciais para que você
            compreenda cada etapa.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {cards.map((c, i) => (
            <motion.article
              key={c.id}
              data-testid={c.tid}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
              className="group relative overflow-hidden border border-white/10 bg-[#0a0a0a] min-h-[420px] md:min-h-[520px] cursor-pointer"
              onClick={startCheckout}
            >
              <div className="absolute inset-0">
                <img
                  src={c.bg}
                  alt=""
                  className="w-full h-full object-cover transition-transform duration-[1.6s] group-hover:scale-110"
                  style={{ filter: "grayscale(100%) contrast(1.1) brightness(0.5)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />
                <div className="absolute inset-0 bg-gradient-to-br from-red-950/40 via-transparent to-transparent mix-blend-multiply opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              </div>

              <div className="relative z-10 h-full flex flex-col justify-between p-7 md:p-10">
                <div className="flex items-start justify-between font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-400">
                  <span className="text-red-500">{c.num}</span>
                  <span>{c.year}</span>
                </div>

                <div>
                  <h3 className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-neutral-50 mb-5">
                    {c.title}
                  </h3>
                  <p className="text-[13px] md:text-sm text-neutral-400 max-w-md leading-relaxed mb-7">
                    {c.desc}
                  </p>
                  <div className="inline-flex items-center gap-3 text-red-500 font-mono text-[11px] tracking-[0.25em] uppercase group-hover:gap-5 transition-all">
                    Ver no ebook
                    <ArrowUpRight className="h-4 w-4" />
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
